<template>
  <div>
    <v-row dense class="ma-4 mt-12">
      <div class="text-h5">Dados Detalhados</div>
    </v-row>

    <v-row dense>
      <v-col cols="5">
        <div class="text-h6 ml-4">Operadores Ativos</div>
        <v-data-iterator
          :no-data-text="noDataText"
          :items="dataOperadoresAtivos"
          :items-per-page.sync="itemsPerPage"
          :page="pageOperadoresAtivos"
          :search="searchOperadoresAtivos"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:header>
            <v-row>
              <v-spacer />
              <v-col cols="4" class="mr-2">
                <v-text-field
                  v-model="searchOperadoresAtivos"
                  clearable
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  label="Busca"
                />
              </v-col>
            </v-row>
          </template>

          <template v-slot:default="props">
            <v-data-table
              dense
              :headers="headerOperadoresAtivos"
              :items="props.items"
              hide-default-footer
              class="elevation-1"
              disable-pagination
            >
              <template v-slot:[`item.queues`]="{ item }">
                <div>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="font-weight-bold bluePcm--text text-uppercase" v-bind="attrs" v-on="on">
                        Ver filas
                      </div>
                    </template>
                    <v-row no-gutters v-for="queue in item.queues" :key="`queue_name_${queue}`">
                      <span class="font-weight-bold">{{ queue }}</span>
                    </v-row>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Operadores:
                  {{ getAdministrativePanelData.operadores.length }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageOperadoresAtivos"
                  :numberOfPages="numberOfPagesOperadoresAtivos"
                  @firstPage="firstPageOperadoresAtivos"
                  @formerPage="formerPageOperadoresAtivos"
                  @nextPage="nextPageOperadoresAtivos"
                  @lastPage="lastPageOperadoresAtivos"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>

      <v-col cols="5" offset="1">
        <div class="text-h6 ml-4">Ramais/Operadores Avaliados</div>
        <v-data-iterator
          :no-data-text="noDataText"
          :items="dataAvaliados"
          :items-per-page.sync="itemsPerPage"
          :page="pageAvaliados"
          :search="searchAvaliados"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:header>
            <v-row>
              <v-spacer />
              <v-col cols="4" class="mr-2">
                <v-text-field
                  v-model="searchAvaliados"
                  clearable
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  label="Busca"
                />
              </v-col>
            </v-row>
          </template>

          <template v-slot:default="props">
            <v-data-table
              dense
              :headers="headerAvaliados"
              :items="props.items"
              hide-default-footer
              class="elevation-1"
              disable-pagination
            >
            </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Ramais/Operadores:
                  {{ getAdministrativePanelData.avaliados.length }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageAvaliados"
                  :numberOfPages="numberOfPagesAvaliados"
                  @firstPage="firstPageAvaliados"
                  @formerPage="formerPageAvaliados"
                  @nextPage="nextPageAvaliados"
                  @lastPage="lastPageAvaliados"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import ListPagination from '@/componentes/ListPagination'

import administrativePanelDataStore from '../_store'

export default {
  components: { ListPagination },
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    dataAvaliados: [],
    dataOperadoresAtivos: [],
    headerAvaliados: [{ text: 'Operador/Ramal', align: 'start', sortable: true, value: 'description' }],
    headerOperadoresAtivos: [
      { text: 'Nome Operador', align: 'start', sortable: true, value: 'operador' },
      { text: 'Código', align: 'end', sortable: true, value: 'numero' },
      { text: 'Filas', align: 'center', sortable: false, value: 'queues' },
    ],
    itemsPerPage: 20,
    searchAvaliados: '',
    searchOperadoresAtivos: '',
    pageAvaliados: 1,
    pageOperadoresAtivos: 1,
  }),

  computed: {
    ...mapGetters('administrativePanelDataStore', ['getAdministrativePanelData', 'getFilaById']),
    numberOfPagesAvaliados() {
      return Math.ceil(this.dataAvaliados.length / this.itemsPerPage)
    },
    numberOfPagesOperadoresAtivos() {
      return Math.ceil(this.dataOperadoresAtivos.length / this.itemsPerPage)
    },
  },

  created() {
    registerVuexModule(this.$store, 'administrativePanelDataStore', administrativePanelDataStore)
  },

  methods: {
    firstPageAvaliados() {
      if (this.pageAvaliados > 1) {
        this.pageAvaliados = 1
      }
    },
    formerPageAvaliados() {
      if (this.pageAvaliados > 1) {
        this.pageAvaliados -= 1
      }
    },
    nextPageAvaliados() {
      if (this.pageAvaliados < this.numberOfPagesAvaliados) {
        this.pageAvaliados += 1
      }
    },
    lastPageAvaliados() {
      if (this.pageAvaliados < this.numberOfPagesAvaliados) {
        this.pageAvaliados = this.numberOfPagesAvaliados
      }
    },
    firstPageOperadoresAtivos() {
      if (this.pageOperadoresAtivos > 1) {
        this.pageOperadoresAtivos = 1
      }
    },
    formerPageOperadoresAtivos() {
      if (this.pageOperadoresAtivos > 1) {
        this.pageOperadoresAtivos -= 1
      }
    },
    nextPageOperadoresAtivos() {
      if (this.pageOperadoresAtivos < this.numberOfPagesOperadoresAtivos) {
        this.pageOperadoresAtivos += 1
      }
    },
    lastPageOperadoresAtivos() {
      if (this.pageOperadoresAtivos < this.numberOfPagesOperadoresAtivos) {
        this.pageOperadoresAtivos = this.numberOfPagesOperadoresAtivos
      }
    },
  },

  watch: {
    getAdministrativePanelData: {
      deep: true,
      immediate: true,
      handler() {
        this.dataAvaliados = this.getAdministrativePanelData.avaliados.map(avaliado => ({ description: avaliado }))
        this.dataOperadoresAtivos = this.getAdministrativePanelData.operadores.map(operador => ({
          operador: operador.operador,
          numero: operador.numero,
          queues: operador.queues.map(fila => this.getFilaById(fila.queue).description || ''),
        }))
      },
    },
  },
}
</script>
